module.exports = __webpack_public_path__ + "static/media/authorized.0f011db5.svg";